// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".repurchase-tit-coin{width:.74667rem;height:.74667rem;margin:0 .18667rem}", ""]);
// Exports
module.exports = exports;
